import React, { ChangeEvent, FC, useState } from 'react';
import LeftPanel from './components/LeftPanel';
import { useLocation, useNavigate } from 'react-router';
import AuthService from '@/services/AuthService';
import CustomInput from './components/subComponents/CustomInput';
import { Icons } from '@/icons';
import Spinner from '@/components/Spinner';

const ResetPassword: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email, otp } = location.state || {};
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
      const [confirmError, setConfirmError] = useState(false);
        const [passwordError, setPasswordError] = useState(false);


  if (!email || !otp) {
    console.log('No email or OTP provided in state:', { email, otp });
    
    return (
      <div className='flex flex-col md:flex-row h-screen'>
        <LeftPanel />
        <div className='w-full md:w-1/2 p-10 flex flex-col items-center justify-center'>
          <h2 className='text-3xl font-semibold mb-1'>OPT</h2>
          <p className='text-sm text-black mb-6'>
            No email provided. Please go back and enter your email.
          </p>
        </div>
      </div>
    );
  }

  const handleSubmit = async () => {
    setIsSubmitting(true);
    
    const result = await AuthService.resetPassword(email, otp, password);
    if (result.success) {
      navigate('/login');
      console.log('Password reset successful');
    }
  };

    const validatePassword = (value: string) => {
    const ok = value.length >= 6;
    setPasswordError(!ok);
    return ok;
  };

    const validateConfirm = (value: string) => {
    const ok = value === password;
    setConfirmError(!ok);
    return ok;
  };

  const isFormValid =
  !passwordError &&
  !confirmError &&
  !!password &&
  !!confirmPassword
  && password === confirmPassword;
  
  return (
    <div className='flex flex-col md:flex-row h-screen'>
      <LeftPanel />

      <div className='w-full md:w-1/2 p-10 flex flex-col items-center justify-center'>

          {/* Password */}
          <CustomInput
            id='password'
            label='Password'
            Icon={Icons.Lock}
            type={showPassword ? 'text' : 'password'}
            placeholder='Enter password here'
            value={password}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setPassword(e.target.value);
              if (passwordError) validatePassword(e.target.value);
            }}
            RightIcon={showPassword ? Icons.EyeOpen : Icons.EyeClose}
            onRightIconClick={() => setShowPassword((v) => !v)}
            error={passwordError}
            errorMessage='Password must be at least 6 characters'
          />

          {/* Confirm Password */}
          <CustomInput
            id='confirmPassword'
            label='Confirm Password'
            Icon={Icons.Lock}
            type={showConfirm ? 'text' : 'password'}
            placeholder='Re-enter password here'
            value={confirmPassword}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setConfirmPassword(e.target.value);
              if (confirmError) validateConfirm(e.target.value);
            }}
            password={password}
            RightIcon={showConfirm ? Icons.EyeOpen : Icons.EyeClose}
            onRightIconClick={() => setShowConfirm((v) => !v)}
            error={confirmError}
            errorMessage='Passwords must match'
          />

          <button
            onClick={handleSubmit}
            type='submit'
            disabled={isSubmitting || !isFormValid}
            className={`w-2/4 py-2 rounded-full mt-4 transition flex items-center justify-center gap-2
                  ${isSubmitting || !isFormValid ? 'bg-pink-400 cursor-not-allowed' : 'bg-[#FF0050] hover:bg-pink-600'}
                `}
          >
            {isSubmitting && <Spinner />}
            <span
              className={
                isSubmitting
                  ? 'opacity-70 text-sm sm:text-base'
                  : 'text-sm sm:text-base'
              }
            >
              Sign In
            </span>
          </button>
      </div>
    </div>
  );
};

export default ResetPassword;
